import PuppyBoarding from './PuppyBoarding';

export default PuppyBoarding;
